
document.addEventListener("DOMContentLoaded", function () {

  const sections = document.querySelectorAll(".scroll-section");

  function checkSections() {

    sections.forEach(section => {

      const rect = section.getBoundingClientRect();

      // Jab section ka top viewport ke top ko touch kare
      if (rect.top <= 0 && rect.bottom > 0) {

        document.body.classList.remove("section-white", "section-black");

        if (section.classList.contains("section-white")) {
          document.body.classList.add("section-white");
        }

        if (section.classList.contains("section-black")) {
          document.body.classList.add("section-black");
        }

      }

    });

  }

  window.addEventListener("scroll", checkSections);
  checkSections(); // page load par bhi check kare

});